/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_3Inputs */



/**
* | output |
* | --- |
* | "Login using your email and password" |
*
* @param {Login_Offline_Instruction_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_3 = /** @type {((inputs?: Login_Offline_Instruction_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous avec votre email et mot de passe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi utilizzando la tua email e password")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Войдите, используя свой адрес электронной почты и пароль.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicie sesión con su correo electrónico y contraseña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用您的电子邮件和密码登录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレスとパスワードを使用してログインしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने ईमेल और पासवर्ड का उपयोग करके लॉग इन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faça login usando seu e-mail e senha.")
	return /** @type {LocalizedString} */ ("Login using your email and password")
});